'use client'

import { useEffect, useRef } from 'react'
import {
  DialogCloseTrigger,
  DialogContent,
  DialogRoot,
} from '@/components/ui/dialog'
import Delivery from './Delivery'
import { IRedux } from '../../_store/types'
import { useSelector } from 'react-redux'
import BranchesDesktop from '../Branches/branches.desktop'
import { mapDesktopLog } from './mapDesktopLog'

const Desktop = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const { order_type } = useSelector((state: IRedux) => state.session)
  const openedAtRef = useRef(0)

  useEffect(() => {
    if (!open) return
    openedAtRef.current = Date.now()
    mapDesktopLog('5 desktop-dialog-mounted', {
      orderType: order_type?.type ?? null,
      showsDeliveryMap: order_type?.type === 'delivery',
    })
  }, [open, order_type?.type])

  return (
    <DialogRoot
      size='md'
      lazyMount
      placement={'center'}
      open={open}
      trapFocus={false}
      onInteractOutside={() => {
        mapDesktopLog('6 interact-outside')
      }}
      onOpenChange={(e) => {
        const elapsedMs = Date.now() - openedAtRef.current
        mapDesktopLog('7 dialog-onOpenChange', {
          nextOpen: e.open,
          elapsedMs,
        })
        if (e.open) return
        // Production click-through: the same pointerup that opened the
        // dialog hits the backdrop and would close it immediately.
        // Mobile skips this because it has no onOpenChange at all.
        if (elapsedMs < 400) {
          mapDesktopLog('7a ignored-immediate-close', { elapsedMs })
          return
        }
        onClose()
      }}
    >
      <DialogContent
        p={0}
        w={'full'}
        rounded={12}
        display='flex'
        flexDir='column'
        overflow={'hidden'}
        h={order_type?.type === 'delivery' ? '608px' : '532px'}
        maxW={order_type?.type === 'delivery' ? '800px' : '1200px'}
      >
        {order_type?.type === 'delivery' ? (
          <Delivery onClose={onClose} />
        ) : (
          <BranchesDesktop onClose={onClose} />
        )}
        <DialogCloseTrigger
          top={8}
          right={8}
          zIndex={1}
          width={10}
          height={10}
          rounded='full'
          bgColor='light'
          boxShadow='4px 4px 12px 0px #00000029'
        />
      </DialogContent>
    </DialogRoot>
  )
}

export default Desktop
